<script lang="ts">
  import { fadeSlide } from "app/transitions";
  import { sectionURL } from "app/utils/urls";
  import { communitySlug } from "app/stores/community";
  import { slugify } from "app/utils/strings";
  import { getMediaQuery } from "app/utils/mediaQuery";
  import { getStores } from "app/stores";
  import { page } from "$app/stores";
  import cx from "classnames";

  export let name: string | undefined = undefined;
  export let sectionUuid: string;

  const { userPreferences } = getStores();
  const isDesktop = getMediaQuery("desktop");

  let path: string;

  $: {
    if (name) {
      path = sectionURL({
        communitySlug: $communitySlug,
        sectionUuid,
        sectionSlug: slugify(name),
      });
    }
  }

  $: isCurrentLocation = $page.url.pathname === path;
</script>

<div class="relative flex min-h-[32px] flex-col overflow-hidden">
  {#if name}
    <a
      in:fadeSlide
      href={sectionURL({
        communitySlug: $communitySlug,
        sectionUuid,
        sectionSlug: slugify(name),
      })}
      on:click={() => !$isDesktop && userPreferences.toggleLeftPanelExpansion()}
      class={cx(
        isCurrentLocation
          ? "text-community-primary"
          : "text-black/80 hover:text-neutral-500 dark:text-white/90 dark:hover:text-white/75",
        "group flex h-[32px] items-center justify-center overflow-hidden p-2 pr-1.5 text-[13px] font-semibold transition-colors duration-75 sm:text-xs"
      )}
    >
      <span class="mr-auto min-w-0 truncate" title={name}>{name}</span>
      <slot name="cta" />
    </a>
  {/if}

  <nav
    class="mb-1 scrollbar-thin overflow-x-hidden overflow-y-auto overscroll-contain scrollbar-stable md:scrollbar-invisible md:hover:scrollbar-visible"
    id={`knowledge-base-index-navigation-${name}`}
  >
    <slot />
  </nav>
</div>
